var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "map-placeholder" } },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c("div", { staticClass: "ui buttons" }),
      _vm._v(" "),
      _c("div", {
        ref: "mapContainer",
        staticClass: "map-container",
        on: { "meta-obs-clicked": _vm.zoomInObs }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "map", attrs: { id: "map" } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }